// Tokens de estilo alinhados ao padrão visual mais recente do projeto
// (Leilão CLT — src/components/CreditAuctionProposalsPage): cards com borda
// arredondada, cabeçalho "eyebrow" (rótulo pequeno, maiúsculo, tracked) e
// contraste label/valor. O theme.ts do projeto só expõe primary/secondary/
// Lexend Deca — o resto (cinzas, radius) é hardcoded ali também, então
// seguimos o mesmo padrão aqui em vez de inventar tokens novos.

export const fieldFont = { fontFamily: "Lexend Deca" };

export const labelStyles = {
  fontFamily: "Lexend Deca",
  fontSize: "sm",
  fontWeight: "500" as const,
  color: "gray.800",
};

export const valueStyles = {
  fontFamily: "Lexend Deca",
  fontSize: "sm",
  fontWeight: "normal" as const,
  color: "#1E293B",
};

export const cardStyles = {
  border: "1px solid",
  borderColor: "#E2E8F0",
  borderRadius: "16px",
  bg: "white",
};

export const eyebrowStyles = {
  fontFamily: "Lexend Deca",
  fontSize: "sm",
  fontWeight: "500" as const,
  color: "secondary",
  letterSpacing: "0.04em",
  textTransform: "uppercase" as const,
};

// `primary`/`secondary` no theme.ts são cores únicas do white-label (não um
// scale .50/.100/.600 como os colorScheme padrão do Chakra), então
// componentes multi-part (Tag, Radio, Checkbox) não conseguem usá-las via
// `colorScheme` — precisam de bg/color/borderColor diretos. Estes helpers
// replicam os variants "solid"/"outline" já customizados pro Button em
// theme.ts, pra usar as cores da marca em pills (Tag) sem quebrar.
export const brandSolid = (color: "primary" | "secondary") => ({
  bg: color,
  color: "white",
});

export const brandOutline = (color: "primary" | "secondary") => ({
  bg: "transparent",
  border: "2px solid",
  borderColor: color,
  color,
});
